import React from 'react'
import { BookingNavigationSection } from './hooks'

const CodesHeading = ({ activeSection }: { activeSection?: BookingNavigationSection }) => {
    return <>{activeSection?.tabHeader}</>
}

export default CodesHeading
